import { render } from "./NotFoundComponent.vue?vue&type=template&id=a577dcde"
const script = {}
script.render = render

export default script